import { createFileRoute } from "@tanstack/react-router";
import { createCanonicalSymbolRouteOptions } from "~/features/symbol/routing/canonical-symbol-route-options";
import { normalizeStockTradeSearch } from "~/features/symbol/routing/stock-trade-search";

export const Route = createFileRoute("/_app/stocks_/$symbol")({
  ...createCanonicalSymbolRouteOptions("stock"),
  validateSearch: normalizeStockTradeSearch,
  ssr: true,
});
